import { countryExchangeRate } from "@/api/newapi.js"


countryExchangeRate({ id: 1 }).then(res => {
    var obj = JSON.stringify(res.data) 
    localStorage.setItem('exchange',obj)
})

